import withProvider from './src/hoc/withProvider'

export const wrapRootElement = withProvider
